import { render, staticRenderFns } from "./ProductConsulting.vue?vue&type=template&id=177b098d&scoped=true&"
import script from "./ProductConsulting.vue?vue&type=script&lang=js&"
export * from "./ProductConsulting.vue?vue&type=script&lang=js&"
import style0 from "./ProductConsulting.vue?vue&type=style&index=0&id=177b098d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b098d",
  null
  
)

export default component.exports